import store from './store'
import { getBreakpoint } from './breakpoint'

const throttle = (type, f, obj = window) => {
    let running = false
    const func = () => {
        if (running) return
        running = true
        requestAnimationFrame(function () {
            f()
            running = false
        })
    }
    obj.addEventListener(type, func)
}

throttle('resize', () => {
    store.breakpoint = getBreakpoint()
    store.windowHeight = window.innerHeight
    store.windowWidth = window.innerWidth
})
